import React from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import axios from 'axios';

const SubscriptionButton = ({ priceId, user, subscription, onManageSubscription, className = "button button-primary" }) => {
  const stripe = useStripe();

  // If the user is not logged in, show a prompt to log in.
//   console.log("user");
//   console.log(user.id);
//   console.log(user);
//   console.log("subscription");
//   console.log(subscription);
  if (!user || !user.id) {
    return (
      <button
        onClick={() => alert("Please log in to subscribe.")}
        className={className}
      >
        Subscribe
      </button>
    );
  }

  // If user is logged in and has an active subscription, show a management button.
  if (subscription && subscription.status && subscription.status !== "none" && subscription.status !== "EXPIRED") {
    // Check for an iOS subscription vs Stripe subscription:
    if (subscription.provider && subscription.provider.toUpperCase() === "IOS") {
      return (
        <button
          onClick={() => alert("To manage your iOS subscription, please open the Settings app on your device.")}
          className={className}
        >
          My Subscription (iOS)
        </button>
      );
    } else if (subscription.provider && subscription.provider.toUpperCase() === "STRIPE") {
      return (
        <button onClick={onManageSubscription} className={className}>
          My Subscription
        </button>
      );
    }
  }

  // Otherwise, if the user is logged in but not subscribed, allow them to subscribe.
  const handleSubscribe = async () => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    
    try {
      const response = await axios.post(
        `${backendUrl}/api/create-checkout-session`,
        { priceId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        }
      );
      
      const sessionId = response.data.sessionId;
      await stripe.redirectToCheckout({ sessionId });
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || error.message || 'Subscription initiation failed.';
      alert('Subscription initiation failed: ' + errorMessage);
    }
  };

  return (
    <button onClick={handleSubscribe} className={className}>
      Subscribe
    </button>
  );
};

export default SubscriptionButton;
